import { IPricingRecord } from "@services/QuoteBuilder/QuoteBuilderService";
import { SplendInitiative } from "@services/customer/CustomerPotentials";
import { PlanType } from "./quotePlanOptions";

export enum QuoteValidationError {
  INVALID_POTENTIAL_STAGE = "INVALID_POTENTIAL_STAGE",
  INVALID_PLAN_TYPE = "INVALID_PLAN_TYPE",
  INVALID_CUSTOMER_LOCATION = "INVALID_CUSTOMER_LOCATION",
  MISSING_MINIMUM_PERIOD_WEEKS_FOR_FT = "MISSING_MINIMUM_PERIOD_WEEKS_FOR_FT",
  UNSUPPORTED_SPLEND_INITIATIVE = "UNSUPPORTED_SPLEND_INITIATIVE",
  VALID = "VALID"
}

/**
 * Used by QuoteErrorView to determine if a quote can be created
 */
export function validateQuote(pricingRecord: IPricingRecord): QuoteValidationError {
  /**
   * Validation order for creation of New Quotes:
   * 1. Checks whether the Zoho Potential stage is valid (not Closed Lost/Won)
   * 2. Checks whether the plan type is supported (only Flexi Own)
   * 3. Checks whether the customer location is populated
   */
  
  // Quotes can only be created when the potential is not closed
  const invalidStages = [
    "Closed Lost",
    "Closed Won",
  ];
  if (invalidStages.includes(pricingRecord?.zoho_potential?.Stage) && pricingRecord?.status === "New") {
    return QuoteValidationError.INVALID_POTENTIAL_STAGE;
  }

  // Flexi Own (New/Used) and Flexi Try plans are supported
  let supportedPlanTypes = [
    PlanType.FLEXI_OWN,
    PlanType.FLEXI_TRY
  ]
  
  if (!supportedPlanTypes.includes(pricingRecord?.plan as PlanType)) {
    return QuoteValidationError.INVALID_PLAN_TYPE;
  }

  // State must be populated on the contact record
  if (pricingRecord?.zoho_contact?.Location === null) {
    return QuoteValidationError.INVALID_CUSTOMER_LOCATION;
  }

  // Splend Initiative must be one of Dynamic Pricing or Ignition
  if (pricingRecord?.plan === PlanType.FLEXI_TRY && ![SplendInitiative.DynamicPricing, SplendInitiative.Ignition].includes(pricingRecord?.splend_initiative as SplendInitiative)) {
    return QuoteValidationError.UNSUPPORTED_SPLEND_INITIATIVE
  }

  // Minimum period weeks must be set for Flexi Try
  if (pricingRecord?.plan === PlanType.FLEXI_TRY && pricingRecord?.minimum_period_weeks === null) {
    return QuoteValidationError.MISSING_MINIMUM_PERIOD_WEEKS_FOR_FT
  }

  return QuoteValidationError.VALID;
}